export interface IRoleViewData {
    _id: string;
    id: string;
    name: string;
    displayName: string;
    isEnabled?: boolean; 
  }
  
  export interface IRoleViewLabel {
    nameLabel: string;
    descriptionLabel: string;
  }
  
  export default class RoleViewData implements IRoleViewData {
    _id: string;
    id: string;
    name: string;
    displayName: string;
    isEnabled?: boolean;  
    constructor(
      _id: string,
      id: string,
      name: string,
      displayName: string,
      isEnabled?: boolean,
    ) {
      this._id = _id;
      this.id = id;
      this.name = name;
      this.displayName = displayName;
      this.isEnabled= isEnabled;
      }
  }
  
  const defaultRoleData = new RoleViewData("", "", "", "", false);
  export { defaultRoleData };
  